import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Predicate, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from './../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { Browser, enableRipple, isNullOrUndefined } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  DataStateChangeEventArgs, IFilter, PageService, PdfExportService, SearchSettingsModel, SelectionSettingsModel, SortService, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { Observable } from 'rxjs';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { MysqlService } from './../../../../services/mysql.service';
import { BsModalService, TabsetComponent } from 'ngx-bootstrap';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { SystemLog } from 'src/app/shared/models/sysLog.model';
import { Brand } from 'src/app/api/brand';
import { ppsDistrHubActionList } from 'src/app/shared/models/ppsDistroHubActionList.model';
import { DataService } from 'src/app/admin/system-log-manager/data.service';


// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';


// Set Syncfuion Culture and Internationalization
import { Internationalization } from '@syncfusion/ej2-base';
import {setCulture} from '@syncfusion/ej2-base';
// setCulture('au');
import { setCurrencyCode} from '@syncfusion/ej2-base';
import { RuleModel, QueryBuilderComponent } from '@syncfusion/ej2-angular-querybuilder';
import { SearchSubject } from 'src/app/shared/models/searchSubject.model';
setCurrencyCode('AUD');
import { projectData, sampleData } from 'src/app/components/grid/jobs-grid/jsontreegredidata';
import { AreaSeriesService, CategoryService, ChartComponent, ColumnSeriesService, IPointEventArgs, LegendService, LineSeriesService, StackingColumnSeriesService, ZoomService } from '@syncfusion/ej2-angular-charts';

import { Chart, LineSeries, DateTime, Legend, Tooltip, ILoadedEventArgs, ChartTheme,Category, ColumnSeries, } from '@syncfusion/ej2-charts';
// import { Browser } from '@syncfusion/ej2-base';


interface Data {
  group: {
    x: string;
  };
  [key: string]: any; // Handles dynamic y fields
}

// interface ChartData {
//   label: string;
//   value: number;
// }



interface OriginalData {
  group: {
    x: string; // User name or identifier
  };
  [key: string]: any; // Handles dynamic y fields
}

interface ChartData {
  user: any;
  [key: string]: number | null; // Dynamic y fields
}


@Component({
  selector: 'app-metric-chart-muliti-series-agent-attempts-all',
  templateUrl: './metric-chart-muliti-series-agent-attempts-all.component.html',
  styleUrls: ['./metric-chart-muliti-series-agent-attempts-all.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService, SortService, DataService, AreaSeriesService, LegendService, ZoomService, CategoryService, ColumnSeriesService, StackingColumnSeriesService, LineSeriesService],

})
export class MetricChartMulitiSeriesAgentAttemptsAllComponent implements OnInit {


  metric_global_colour = '#5FDDB3'; // aqua score colour
  metric_global_icon = 'fa fa-clock-o';


  metric_1_colour = '#457EDD'; // blue
  metric_1_icon = 'fa fa-clock-o';
  metric_2_colour = '#000'; //  Pink
  metric_2_icon = 'fa fa-clock-o';
  metric_3_colour = '#A2D369'; // 
  metric_3_icon = 'fa fa-clock-o';
  metric_4_colour = '#FA6F50'; // 
  metric_4_icon = 'fa fa-clock-o';
  metric_5_colour = '#FECF56'; // 
  metric_5_icon = 'fa fa-clock-o';
  metric_6_colour = '#62ADE5'; // sharmans lite blue
  metric_6_icon = 'fa fa-clock-o';



  public marker_M1_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    opacity: 0.2,
    fill:  this.metric_1_colour,
  };



  public marker_M2_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    opacity: 0.2,
    fill:  this.metric_2_colour,
  };


  public marker_M3_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    opacity: 0.2,
    fill:  this.metric_3_colour,
  };

  public marker_M4_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    opacity: 0.2,
    fill:  this.metric_4_colour,
  };

  public marker_M5_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    opacity: 0.2,
    fill:  this.metric_5_colour,
  };

  public marker_M6_Benchmark_Differences: Object = {
    visible: true,
    width: 10,
    height: 10,
    shape: 'Triangle',
    opacity: 0.2,
    fill:  this.metric_6_colour,
  };


  public marker_Benchmark_Score: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Diamond',
    opacity: 0.2,
    fill:  this.metric_1_colour,
   
  };
  public marker_Benchmark_Score_M2: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Diamond',
    opacity: 0.2,
    fill:  this.metric_2_colour,

  };
  public marker_Benchmark_Score_M3: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Diamond',
    opacity: 0.2,
    fill:  this.metric_3_colour,
 
  };
  public marker_Benchmark_Score_M4: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Diamond',
    opacity: 0.2,
    fill:  this.metric_4_colour,

  };
  public marker_Benchmark_Score_M5: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Diamond',
    opacity: 0.2,
    fill:  this.metric_5_colour,
  };
  public marker_Benchmark_Score_M6: Object = {
    visible: true,
    width: 5,
    height: 5,
    shape: 'Diamond',
    opacity: 0.2,
    fill:  this.metric_6_colour,
  };

  public marker_Benchmark_Score_Global: Object = {
    visible: true,
    width: 25,
    height: 25,
    shape: 'Diamond',
    fill:  this.metric_global_colour,
    opacity: 0.6
  };



  loading = true;

  //component initialization
  @ViewChild('chart')
  public chart: Chart;

     // setup as observable?
     @Input() item_id?: any; // impliments on changes.
     @Input() item_data? // if data.model is sent : Observable<any[]>;
     @Input() item_data2? // if data.model is sent : Observable<any[]>;
     @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
     @Input() item_user_level_id? = '5'; // default to agent just in case
     @Input() item_brand_type_id? = '';
     @Input() show_buttons? = 'no'; // yes | no
     @Input() widget_title? = '';
     @Input() widget_size? = 'side'; // side | abstract | full


     // chart 
     public primaryXAxis: Object;
     public primaryYAxis: Object;
     public title: string;
     public data: any[];
     public dynamicSeries: any[]; // Array to hold dynamically created series
  
  
  
     tooltip: { enable: boolean; format: string; shared: boolean; };
  
  
  primaryXAxis2: { interval: number; };
  primaryYAxis2: { title: string; };
  title2: string;
   
     // Sample original data structure
    //  public item_data: any[] = [ /* Your provided data */ ];
   

    public marker1: Object = {
      visible: true,
      width: 60,
      height: 60,
      shape: 'Diamond',
      fill: '#fff',
  };
  public marker_score = { visible: true, width: 10, height: 10, shape: 'Star' };
  lineData;
  axes: {
    name: string; title: string; opposedPosition: boolean; // Position the secondary axis on the opposite side
    labelFormat: string;
  }[];
  lineData2: any;
  
//   lineData: Object[] = [
//     { x: 'Neil_Sharman', y: 28 }, 
//     { x: 'Systems_Administrator', y: 101 },
//     // { x: 2007, y: 26 }, 
//     // { x: 2008, y: 27 },
//     // { x: 2009, y: 32 }, 
//     // { x: 2010, y: 35 }, 
//     // { x: 2011, y: 30 }
// ];


public markerScore: Object = {
  visible: true,
  width: 10,
  height: 10,
  shape: 'Diamond',
  fill: '#fff',
};


public marker2: Object = {
  visible: true,
  width: 5,
  height: 5,
  shape: 'Triangle',
  fill: '#fff',
};

public marker3: Object = {
  visible: true,
  width: 5,
  height: 5,
  shape: 'Square',
  fill: '#fff',

};
public marker4: Object = {
  visible: true,
  width: 5,
  height: 5,
  shape: 'Triangle',
  fill: '#fff',

};



  zoom: { enableSelectionZooming: boolean; enablePan: boolean; mode: string; enableAnimation: boolean; };
  animation: { enable: boolean; };
  legend: { visible: boolean; };
  lineData4: any;
  lineDataScore: any;
  lineData_Benchmark_Score_M1: any;
  lineData2_M2_Benchmark_Differences: any;
  lineData2_M3_Benchmark_Differences: any;
  lineData2_M4_Benchmark_Differences: any;
  lineData2_M5_Benchmark_Differences: any;
  lineData2_M6_Benchmark_Differences: any;
  mappedAttempts: any;
  tooltip2: { enable: boolean; };
  lineData_Benchmark_Score: any;
  lineData_Benchmark_Score_M2: any[];
  lineData_Benchmark_Score_M3: any[];
  lineData_Benchmark_Score_M4: any[];
  lineData_Benchmark_Score_M5: any[];
  lineData_Benchmark_Score_M6: any[];




  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService,
   private modalService: BsModalService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   private _mysqlService: MysqlService,

  ) {


    // this.data = null;
    // this.dynamicSeries = [];


   }

  ngOnInit(): void {

    // this.chart.refresh();







    
  // Sample data from your original model
    // this.data = [
    //   { group: { x: 'Systems_Administrator' }, y1: { count: 43 }, y2: { count: 39 } },
    //   { group: { x: 'Network_Administrator' }, y1: { count: 25 } } // y2 is missing for this user
    // ];


 


  }


  ngOnChanges(changes: SimpleChanges) {





    if (changes.item_data) {

      this.loading = true; // Begin loading state
      this.data = null;
      this.dynamicSeries = [];


      this.item_data = changes.item_data.currentValue;
      // Transform item_data for stacked columns
      this.data = this.transformItemData(this.item_data);
    }

    // Process item_data2 for system averages
    if (changes.item_data2) {
      this.item_data2 = changes.item_data2.currentValue;
    }

    // Setup dynamicSeries with stacked columns and system average lines
    this.setupDynamicSeries();

    // Set chart properties, refresh chart, and end loading state
    this.setChartProperties();
  

    this.mappedAttempts = this.mapItemDataToAttempts(this.item_data);

    this.lineData_Benchmark_Score = this.getLineData_Benchmark_Score(this.mappedAttempts);
    this.lineData_Benchmark_Score_M2 = this.getLineData_Benchmark_Score_M2(this.mappedAttempts);
    this.lineData_Benchmark_Score_M3 = this.getLineData_Benchmark_Score_M3(this.mappedAttempts);
    this.lineData_Benchmark_Score_M4 = this.getLineData_Benchmark_Score_M4(this.mappedAttempts);
    this.lineData_Benchmark_Score_M5 = this.getLineData_Benchmark_Score_M5(this.mappedAttempts);
    this.lineData_Benchmark_Score_M6 = this.getLineData_Benchmark_Score_M6(this.mappedAttempts);
}





// Function to transform item_data with default values
 // Function to transform item_data with default values for metrics
transformItemData(itemData) {
    return itemData.map(agent => ({
        log_type_name: agent.log_type_name,
        // count: agent.count ?? 0,
        metric_1: this.parseMetric(agent.metric_1) ?? 0,
        metric_2: this.parseMetric(agent.metric_2) ?? 0,
        metric_3: this.parseMetric(agent.metric_3) ?? 0,
        metric_4: this.parseMetric(agent.metric_4) ?? 0,
        metric_5: this.parseMetric(agent.metric_5) ?? 0,
        metric_6: this.parseMetric(agent.metric_6) ?? 0,
    }));
}

// Convert metric strings to days
parseMetric(metric) {
    if (!metric) return 0; // Return 0 if metric is null or undefined
    const matches = metric.match(/\d+/g);
    if (matches) {
        const [days, hours, minutes, seconds] = matches.map(Number);
        return days + hours / 24 + minutes / 1440 + seconds / 86400; // Converts to days
    }
    return 0;
}



getLineData_Benchmark_Score(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_1  // Replace with the appropriate metric or value

  }));
}

getLineData_Benchmark_Score_M2(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_2  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M3(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_3  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M4(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_4  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M5(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_5  // Replace with the appropriate metric or value

  }));
}
getLineData_Benchmark_Score_M6(mappedAttempts: any[]): any[] {
  if (!mappedAttempts || mappedAttempts.length === 0) {
    return [];
  }
  return mappedAttempts.map(attempt => ({
    x: attempt.subject_number, // Map to subject_number
    y: attempt.score_metric_6  // Replace with the appropriate metric or value

  }));
}



// Setup dynamic series including system average lines with diamond markers
setupDynamicSeries() {
    // Define stacked column series for each agent metric
    this.dynamicSeries = [
        // { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'count', name: 'Count' },
        { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'metric_1', name: 'Metric 1', fill: this.metric_1_colour },
        { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'metric_2', name: 'Metric 2', fill: this.metric_2_colour  },
        { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'metric_3', name: 'Metric 3', fill: this.metric_3_colour  },
        { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'metric_4', name: 'Metric 4', fill: this.metric_4_colour  },
        { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'metric_5', name: 'Metric 5', fill: this.metric_5_colour  },
        { dataSource: this.data, type: 'StackingColumn', xName: 'log_type_name', yName: 'metric_6', name: 'Metric 6', fill: this.metric_6_colour  },
    ];

    // Add line series for each system average metric
    if (this.item_data2) {
        const lineSeries = this.transformSystemAverageData(this.item_data2);
        this.dynamicSeries = this.dynamicSeries.concat(lineSeries);
    }




// :: Ok this ok ok To map and benchmark eech metrick
// BUT.... I need to do a total 



  // Populate lineData with score differences for each user
          this.lineDataScore = this.item_data
          .map(item => ({
            x: item.name,
            y: item.score ?? 0, // Fallback to 0 if missing
            color: item.user_colour,
            icon: item.user_icon
          }))
          .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

          // Handle cases where lineData is empty by providing a placeholder
          if (this.lineDataScore.length === 0) {
          this.lineDataScore = [{ x: 'No Data', y: 0 }];
          }


       // Populate lineData with score differences for each user
          this.lineData2 = this.item_data
          .map(item => ({
              x: item.name,
            //  x: 'BM Difference',
              y: item.benchmark_difference_metric_1 ?? 0, // Fallback to 0 if missing
              color: item.user_colour,
              icon: item.user_icon
          }))
          .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

          // Handle cases where lineData is empty by providing a placeholder
          if (this.lineData2.length === 0) {
          this.lineData2 = [{ x: 'No Data', y: 0 }];
          }




          
        // Benchmarks
        this.lineData4 = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark, // Fallback to 0 if missing
            color: item.user_colour,
            icon: item.user_icon
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData4.length === 0) {
        this.lineData4 = [{ x: 'No Data', y: 0 }];
        }


        // Benchmarks/Differences
        this.lineData_Benchmark_Score_M1 = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark_difference_metric_1, // Fallback to 0 if missing
            color: this.metric_global_colour,
            icon: this.metric_global_icon
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData_Benchmark_Score_M1.length === 0) {
        this.lineData_Benchmark_Score_M1 = [{ x: 'No Data', y: 0 }];
        }

        
        this.lineData2_M2_Benchmark_Differences = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark_difference_metric_2, // Fallback to 0 if missing
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData2_M2_Benchmark_Differences.length === 0) {
        this.lineData2_M2_Benchmark_Differences = [{ x: 'No Data', y: 0 }];
        }

        this.lineData2_M3_Benchmark_Differences = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark_difference_metric_3, // Fallback to 0 if missing
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData2_M3_Benchmark_Differences.length === 0) {
        this.lineData2_M3_Benchmark_Differences = [{ x: 'No Data', y: 0 }];
        }

        this.lineData2_M4_Benchmark_Differences = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark_difference_metric_4, // Fallback to 0 if missing
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData2_M4_Benchmark_Differences.length === 0) {
        this.lineData2_M4_Benchmark_Differences = [{ x: 'No Data', y: 0 }];
        }


        this.lineData2_M5_Benchmark_Differences = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark_difference_metric_5, // Fallback to 0 if missing
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData2_M5_Benchmark_Differences.length === 0) {
        this.lineData2_M5_Benchmark_Differences = [{ x: 'No Data', y: 0 }];
        }

        this.lineData2_M6_Benchmark_Differences = this.item_data
        .map(item => ({
            x: item.name,
            // y: this.parseMetric(item.benchmark) ?? 0, // Fallback to 0 if missing
            y: item.benchmark_difference_metric_6, // Fallback to 0 if missing
        }))
        .filter(point => point.y !== undefined && point.y !== null); // Ensure valid y values

        // Handle cases where lineData is empty by providing a placeholder
        if (this.lineData2_M6_Benchmark_Differences.length === 0) {
        this.lineData2_M6_Benchmark_Differences = [{ x: 'No Data', y: 0 }];
        }
        

        


}

// Create line series data for system average metrics with diamond markers
transformSystemAverageData(itemData2) {
    const averageMetrics = {
        metric_1: this.parseMetric(itemData2.system_average_metric_1) ?? 0,
        metric_2: this.parseMetric(itemData2.system_average_metric_2) ?? 0,
        metric_3: this.parseMetric(itemData2.system_average_metric_3) ?? 0,
        metric_4: this.parseMetric(itemData2.system_average_metric_4) ?? 0,
        metric_5: this.parseMetric(itemData2.system_average_metric_5) ?? 0,
        metric_6: this.parseMetric(itemData2.system_average_metric_6) ?? 0,
    };

    const lineSeries = [];
    const colors = ['#FF0000', '#00FF00', '#0000FF', '#FFA500', '#800080', '#008080'];

    // Create a line series for each metric
    Object.keys(averageMetrics).forEach((metricKey, index) => {
        const dataPoints = this.data.map(agent => ({
            x: agent.log_type_name,
            y: averageMetrics[metricKey]
        }));

        // lineSeries.push({
        //     dataSource: dataPoints,
        //     type: 'Line',
        //     xName: 'x',
        //     yName: 'y',
        //     // name: `Global ${metricKey.replace('metric_', 'Metric ')}`, // E.g., "Global Metric 1"
        //     name: `Global ${metricKey.replace('benchmark_difference_metric_', 'Metric ')}`, // E.g., "Global Metric 1"
        //     marker: { visible: true, shape: 'Diamond', width: 10, height: 10 },
        //     width: 2,
        //     fill: colors[index % colors.length]
        // });
    });

    return lineSeries;
}

// Set chart properties as needed
setChartProperties() {
    this.primaryXAxis = {
        title: 'Agents (log_type_name)',
        valueType: 'Category'
    };

    this.primaryYAxis = {
        title: 'Metrics (Days)',
        labelFormat: '{value}',
    };

    this.title = 'Agent Attempt Metrics with System Averages with Benchmark/Scores';

    // this.tooltip = {
    //     enable: true,
    //     format: '${series.name}<br/>${point.x} : ${point.y} Days',
    //     shared: false
    // };










    // Tooltip configuration
    this.tooltip = {
      enable: true,
      format: '${point.x} : ${point.y} (Days) <br> ${series.name}<br/> ',
      shared: false,
      };


      this.zoom = {
      enableSelectionZooming: true,
      enablePan: true,
      mode: 'XY',
      enableAnimation: true
      };
      this.animation = { enable: false};
      this.legend = { visible: true };

      this.tooltip2 = {
        enable: true
    };


      if (this.chart) {
        this.chart.refresh(); // Refresh the chart
      }
      this.loading = false;


}

mapItemDataToAttempts(item_data: any[]): any[] {
  if (!item_data || !Array.isArray(item_data)) {
    console.warn('Invalid item_data:', item_data);
    return [];
  }

  // Initialize an array to store mapped attempts for all agents
  const allAttempts = [];

  // Iterate over all agents in the item_data array
  item_data.forEach(agent => {
    if (Array.isArray(agent.agent_attempts_array) && agent.agent_attempts_array.length > 0) {
      // Map each attempt for the current agent
      const mappedAttempts = agent.agent_attempts_array.map((attempt, index) => ({
        attempt_number: index + 1, // Attempt sequence number
        metric_1: this.parseMetric(attempt.metric_1),
        metric_2: this.parseMetric(attempt.metric_2),
        metric_3: this.parseMetric(attempt.metric_3),
        metric_4: this.parseMetric(attempt.metric_4),
        metric_5: this.parseMetric(attempt.metric_5),
        metric_6: this.parseMetric(attempt.metric_6), // Formatted date
        benchmark_metric_1: attempt.benchmark_metric_1, // Days
        benchmark_metric_2: attempt.benchmark_metric_2,
        benchmark_metric_3: attempt.benchmark_metric_3,
        benchmark_metric_4: attempt.benchmark_metric_4,
        benchmark_metric_5: attempt.benchmark_metric_5,
        benchmark_metric_6: attempt.benchmark_metric_6,
        benchmark_difference_metric_1: attempt.benchmark_difference_metric_1,
        benchmark_difference_metric_2: attempt.benchmark_difference_metric_2,
        benchmark_difference_metric_3: attempt.benchmark_difference_metric_3,
        benchmark_difference_metric_4: attempt.benchmark_difference_metric_4,
        benchmark_difference_metric_5: attempt.benchmark_difference_metric_5,
        benchmark_difference_metric_6: attempt.benchmark_difference_metric_6,
        score: attempt.score, // Overall score for the attempt
        score_metric_1: attempt.score_metric_1, // Score for metric 1
        score_metric_2: attempt.score_metric_2, // Score for metric 2
        score_metric_3: attempt.score_metric_3, // Score for metric 3
        score_metric_4: attempt.score_metric_4, // Score for metric 4
        score_metric_5: attempt.score_metric_5, // Score for metric 5
        score_metric_6: attempt.score_metric_6, // Score for metric 6
        log_type_name: agent.log_type_name, // Agent name
        subject_number: attempt.subject_number,
      }));

      // Append the mapped attempts for the current agent to the result array
      allAttempts.push(...mappedAttempts);
    } else {
      console.warn(`Agent ${agent.log_type_name} has no valid attempts.`);
    }
  });

  return allAttempts;
}

// mapItemDataToAttempts(item_data: any[]): any[] {
//   if (!item_data || !Array.isArray(item_data)) {
//     console.warn('Invalid item_data:', item_data);
//     return [];
//   }

//   // Find the first agent with a non-empty agent_attempts_array
//   const validAgent = item_data.find(agent => Array.isArray(agent.agent_attempts_array) && agent.agent_attempts_array.length > 0);

//   if (!validAgent) {
//     console.warn('No valid agents with attempts found.');
//     return [];
//   }

//   // Map the valid agent's attempts
//   return validAgent.agent_attempts_array.map((attempt, index) => ({
//     attempt_number: index + 1, // Attempt sequence number
//     metric_1: this.parseMetric(attempt.metric_1),
//     metric_2: this.parseMetric(attempt.metric_2),
//     metric_3: this.parseMetric(attempt.metric_3),
//     metric_4: this.parseMetric(attempt.metric_4),
//     metric_5: this.parseMetric(attempt.metric_5),
//     metric_6: this.parseMetric(attempt.metric_6),   // formatted dated
//     benchmark_metric_1: attempt.benchmark_metric_1, // days
//     benchmark_metric_2: attempt.benchmark_metric_2,
//     benchmark_metric_3: attempt.benchmark_metric_3,
//     benchmark_metric_4: attempt.benchmark_metric_4,
//     benchmark_metric_5: attempt.benchmark_metric_5,
//     benchmark_metric_6: attempt.benchmark_metric_6,
//     benchmark_difference_metric_1: attempt.benchmark_difference_metric_1,
//     benchmark_difference_metric_2: attempt.benchmark_difference_metric_2,
//     benchmark_difference_metric_3: attempt.benchmark_difference_metric_3,
//     benchmark_difference_metric_4: attempt.benchmark_difference_metric_4,
//     benchmark_difference_metric_5: attempt.benchmark_difference_metric_5,
//     benchmark_difference_metric_6: attempt.benchmark_difference_metric_6,
//     score: attempt.score, // Overall score for the attempt
//     score_metric_1: attempt.score_metric_1, // Overall score for the attempt
//     score_metric_2: attempt.score_metric_2, // Overall score for the attempt
//     score_metric_3: attempt.score_metric_3, // Overall score for the attempt
//     score_metric_4: attempt.score_metric_4, // Overall score for the attempt
//     score_metric_5: attempt.score_metric_5, // Overall score for the attempt
//     score_metric_6: attempt.score_metric_6, // Overall score for the attempt
//     log_type_name: validAgent.log_type_name, // Agent name
//     subject_number: attempt.subject_number,
//   }));



  
// }



}
